import UI from "@mile-meeting/mile-ui";
import { TWorkspace } from "@mile-meeting/mile-ui/dist/component/Navigation/top-nav/top-nav";
import { logout } from "apis/auth/logout";
import { accessWorkspace } from "apis/auth/member";
import { getUsersMemberList, TUser } from "apis/user/index";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { member, workspace, complainManager } from "recoil/recoilState";
import SlackConnectWarning from "uis/top-bar/slack-connect-warning";
import { encrypt } from "utils/crypto";
import { UserRole } from "utils/role";
import { PageAccessUtils } from "./utils";

const Root = ({ children }: { children?: JSX.Element | JSX.Element[] }) => {
  const workspaceInfo = useRecoilValue(workspace);
  const memberInfo = useRecoilValue(member);
  const [open, setOpen] = useState<boolean>(true);
  const location = useLocation().pathname.split("/");
  const [workspaceList, setWorkspaceList] = useState<TUser[]>([]);
  const navigate = useNavigate();
  const complainManagerState = useRecoilValue(complainManager);

  const pages = new PageAccessUtils();

  const onHandleAccessWorkspace = async (workspace: TWorkspace) => {
    const res = await accessWorkspace(workspace);
    if (res.success && res.accessToken) {
      if (res.user?.autoLogin) localStorage.setItem("access-token", encrypt(res.accessToken));
      else if (res.user?.autoLogin === false) sessionStorage.setItem("access-token", encrypt(res.accessToken));
      window.location.reload();
    }
  };

  const onHandleLogout = async () => {
    const res = await logout();

    localStorage.clear();
    sessionStorage.clear();

    window.location.href = "/login";
  };

  const getSection = (section: string): "setting" | "meeting" | "visitors" | "analytics" => {
    switch (section) {
      case "setting":
        return "setting";
      case "meeting":
        return "meeting";
      case "visitors":
        return "visitors";
      case "analytics":
        return "analytics";
      default:
        return "setting";
    }
  };

  useEffect(() => {
    getUsersMemberList().then((data: { success: boolean; members?: TUser[] }) => {
      if (data.success && data.members) {
        setWorkspaceList(data.members);
      }
    });
  }, []);

  if (!workspaceInfo) return <></>;
  return (
    <div style={{ display: "flex", flex: 1, width: "100%" }}>
      <div style={{ position: "fixed", top: 0, left: 0, zIndex: 200 }}>
        <UI.Navigation.GNB.GNB
          onClickBook={() =>
            window.open(
              "https://mile-corporation.notion.site/12ea222a9c1b81fea00ed25118dd9673?v=12ea222a9c1b81c7a00e000c531b930e"
            )
          }
          onClickLogo={() => navigate("/")}
          showIndex={open}
          onClickFoldIndex={() => {
            setOpen(false);
          }}
          selected={{
            section: getSection(location[1]),
            second: decodeURIComponent(location[2]),
            third: decodeURIComponent(location[3]),
          }}
          height="100vh"
          pages={pages.getPages(
            workspaceInfo,
            complainManagerState ?? false,
            (memberInfo?.role as UserRole) ?? "Staff"
          )}
          onClickSection={(section, second, third) => {
            if (section === location[1]) {
              setOpen(!open);
            } else {
              const route = `${section}/${encodeURIComponent(second ?? "")}/${third ? encodeURIComponent(third) : ""}`;
              window.location.href = `/${route}`;
            }
          }}
          onClickPage={(section, second, third) => {
            const route = `${section}/${encodeURIComponent(second ?? "")}/${third ? encodeURIComponent(third) : ""}`;
            window.location.href = `/${route}`;
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: open ? "264px" : "60px",
          width: "100%",
          boxSizing: "border-box",
          height: "100vh",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <UI.Navigation.TopNav
            isShowLogo={false}
            workspaceId={workspaceInfo?.id}
            workspacePicture={
              workspaceInfo?.image ?? "https://mile-storage.s3.ap-northeast-2.amazonaws.com/web/mile-logo-gray.png"
            }
            profilePicture={memberInfo?.image}
            workspaceName={workspaceInfo?.name}
            profileName={memberInfo?.nickname}
            onHandleWorkspaceManage={() => {
              navigate("/setting/워크스페이스%20관리");
            }}
            onHandleMemberManage={() => {
              navigate("/setting/내%20정보%20관리");
            }}
            isShowLogout
            isShowWorkspace
            isShowProfile
            onHandleLogout={onHandleLogout}
            onHandleWorkspaceList={() => (window.location.href = "/workspace/list")}
            workspaceList={workspaceList}
            onClickWorkspaceItem={onHandleAccessWorkspace}
          />
          <SlackConnectWarning />
        </div>
        <div
          style={{
            overflowX: "auto",
            display: "flex",
            flexDirection: "column",
            maxWidth: "100%",
            height: "100%",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Root;
